export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">
          欢迎与我们取得联系，反馈意见或推荐好片
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100/70 border border-background-200/60 rounded-xl p-6 text-center transition-all duration-200 hover:-translate-y-1 cursor-pointer">
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-line text-primary-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">邮件联系</h3>
            <p className="text-xs text-foreground-500">feedback@nightcat.cinema</p>
          </div>

          <div className="bg-background-100/70 border border-background-200/60 rounded-xl p-6 text-center transition-all duration-200 hover:-translate-y-1 cursor-pointer">
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-wechat-line text-accent-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">微信客服</h3>
            <p className="text-xs text-foreground-500">NightCatCinema</p>
          </div>

          <div className="bg-background-100/70 border border-background-200/60 rounded-xl p-6 text-center transition-all duration-200 hover:-translate-y-1 cursor-pointer">
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className="ri-message-3-line text-secondary-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">在线留言</h3>
            <p className="text-xs text-foreground-500">7×24小时在线</p>
          </div>
        </div>
      </div>
    </section>
  );
}